var ProgramVOSoftware = /** @class */ (function () {
    function ProgramVOSoftware() {
        this.outputColor = new Float32Array([0, 0, 0, 1]);
        this.discard = false;
    }
    return ProgramVOSoftware;
}());
export { ProgramVOSoftware };
